import React from 'react';
import { Grid } from 'semantic-ui-react';
import Form from '../components/Form';

const Inline = props => {
  return (
    <Grid>
      <Grid.Column computer="1" tablet="1" only="computer tablet" />
      <Grid.Column computer="14" tablet="14" mobile="16">
        <Form {...props} />
      </Grid.Column>
      <Grid.Column computer="1" tablet="1" only="computer tablet" />
    </Grid>
  );
};

export default Inline;
